<template>
  <a-card>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder/>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="卡号">
                <a-input v-model.trim="queryParam.cardNo" placeholder/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="业务类型">
                <a-select
                  v-model="queryParam.businessTypeId"
                  :filterOption="filterOption"
                  @change="handleBizChange"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in bizList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="物流状态">
                <a-select v-model="queryParam.logStatus" :filterOption="filterOption" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.value">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="磅单状态">
                <a-select v-model="queryParam.deleted" :filterOption="filterOption" placeholder="全选">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option value="0">正常</a-select-option>
                  <a-select-option value="1">已作废</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="客户/供应商">
                <a-select
                  v-model="queryParam.supplierOrBusId"
                  showSearch
                  :filterOption="filterOption"
                  placeholder="请选择"
                  default-value="0"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option v-for="(item, index) in supplierOrBusList" :key="index" :value="item.id">{{
                    item.name
                    }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="司机姓名">
                <a-input v-model.trim="queryParam.driverName" placeholder/>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item
                label="创建时间"
                :labelCol="{ lg: { span: 7 }, sm: { span: 7 } }"
                :wrapperCol="{ lg: { span: 10 }, sm: { span: 17 } }"
              >
                <a-range-picker
                  v-model="queryParam.createTime"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{
                    今天: [moment().startOf('day'), moment().endOf('day')],
                    本月: [moment().startOf('month'), moment().endOf('day')],
                  }"
                  showTime
                  format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="(!advanced && 8) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              <!--    <a-button style="margin-left: 8px" type="primary"  @click="handleExport()">导出</a-button>-->
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :pagination="{
        pageSizeOptions: pageSizeOptionsList,
        showTotal: (total) => `共${total}条`,
        showQuickJumper: true,
      }"
      :scroll="{ x: 1920 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ record.deleted === 0 ? '正常' : '已作废' }}
        <span class="blacktr" v-if="record.deleted === 1"> </span>
        <span class="removeblacktr" v-if="record.deleted === 0"> </span>
      </span>

      <span slot="supplierName" slot-scope="text, record, index">{{
        record.businessTypeId === config.BusinessTypeId.sell ? record.businessName : record.supplierName
      }}</span>

      <span slot="materielName" slot-scope="text, record, index">
        <a-dropdown>
          <a class="ant-dropdown-link" href="javascript:void(0);">
            {{ text }}
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-for="(item, index) in record.materielList">
              <a-form layout="inline">
                <a-row :gutter="72">
                  <a-col :md="12" :sm="24">
                    <a-form-item label="货物名称：">
                      <span>{{ item.materielName }}</span>
                    </a-form-item>
                  </a-col>

                  <a-col :md="6" :sm="24">
                    <a-form-item label="预约总量：">
                      <span>{{ item.predictQuantity }}</span>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row type="flex" justify="center" v-for="(order, index) in item.orderList">
                  <a-col :md="10" :sm="24">
                    <a-form-item label="订单号：">
                      <span>{{ order.orderNo }}</span>
                    </a-form-item>
                  </a-col>

                  <a-col :md="7" :sm="24">
                    <a-form-item label="剩余量：">
                      <span>{{ order.residueQuantity }}</span>
                    </a-form-item>
                  </a-col>
                  <a-col :md="7" :sm="24">
                    <a-form-item label="预约量：">
                      <span>{{ order.predictQuantity }}</span>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row type="flex" justify="center" v-if="item.weighing != null">
                  <a-col :md="14" :sm="24">
                    <a-form-item label="称重单号：">
                      <span>{{ item.weighing.weighingNo }}</span>
                    </a-form-item>
                  </a-col>

                  <a-col :md="5" :sm="24">
                    <a-form-item label="皮重：">
                      <span>{{ item.weighing.tare }}</span>
                    </a-form-item>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-form-item label="毛重：">
                      <span>{{ item.weighing.gross }}</span>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
              <hr/>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>

      <span slot="materielAction" slot-scope="text, record">
        <a @click="handleProDetail(record.materielVo)" class="ant-dropdown-link">{{ text }}</a>
      </span>

      <span slot="action" slot-scope="text, record, index">
        <a v-show="roleId == config.RoleType.ADMIN" @click="correctRecord(record)">补单</a>
        <a-divider type="vertical"/>
        <a @click="handleDetail(record)">详情</a>
        <a-divider type="vertical" v-if="rolelimit == true"/>
        <a v-if="rolelimit == true" @click="handleBackStep(record)">回退</a>
        <a-divider type="vertical" v-if="rolelimit == true"/>
        <a @click="handleDeleted(record)" v-if="rolelimit == true">{{ record.deleted === 0 ? '作废' : '恢复' }}</a>
        <a-divider type="vertical" v-if="rolelimit == true"/>
        <!-- <a
          v-show="roleId === config.RoleType.ADMIN && record.status === '999' && record.deleted === 0"
          @click="changeBusiness(record)"
          >换客户</a
        > -->
      </span>
    </s-table>

    <a-modal
      title="更换客户"
      style="top: 10px"
      :width="800"
      v-model="changeBusinessVisable"
      @ok="changeBusinessOk"
      destroyOnClose
      :confirmLoading="false"
    >
      <a-form :form="changeBusinessform">
        <a-form-item label="物流号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="物流号"
            v-model="mdlc.logisticsNo"
            v-decorator="[
              'logisticsNo',
              { initialValue: mdlc.logisticsNo, rules: [{ required: true, message: '请输入物流号' }] },
            ]"
            v-bind:disabled="true"
          />
        </a-form-item>

        <a-form-item label="原客户名" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-input
            placeholder="原客户名"
            v-model="mdlc.yname"
            v-decorator="['yname', { initialValue: mdlc.yname, rules: [{ required: true, message: '请原客户名' }] }]"
            v-bind:disabled="true"
          />
        </a-form-item>

        <a-form-item label="变更客户" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
          <a-select
            v-model="mdlc.id2"
            placeholder="请选择"
            v-decorator="['id2', { initialValue: mdlc.id2, rules: [{ required: true, message: '请选择变更客户' }] }]"
            showSearch
            :filterOption="filterOption"
          >
            <a-select-option v-for="(item, index) in businessList" :key="index" :value="item.id">{{
              item.name
              }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>


    <a-modal title="补单" style="top: 10px" :confirmLoading="showLoading" :width="800" v-model="visible" @ok="handleOk">
      <a-form :form="form">
        <a-row :gutter="18">
          <a-col :span="12">
            <a-form-item label="业务类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input :disabled="disabled" v-model="mdl.businessTypeName"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="物流单号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input :disabled="disabled" v-model="mdl.logisticsNo"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="毛重" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input-number  :precision="precision" v-model="mdl.gross" :min="0" @change="handleGrossChange" style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="客户/供应商" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input :disabled="disabled" v-model="mdl.supplierOrBusName"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="皮重" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input-number  :precision="precision" :min="0" v-model="mdl.tare" @change="handleTareChange" style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="物料名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-select :disabled="disabled" v-model="materielId" :filterOption="filterOption" placeholder="请选择">
                <a-select-option v-for="(item, index) in materielList" :key="index" :value="item.materielId">{{
                  item.materielName
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="净重" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input-number :disabled="disabled" :min="0" v-model="mdl.net" style="width: 100%"/>
            </a-form-item>
          </a-col>

<!--
          <a-col :span="12">
            <a-form-item label="扣杂类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-select
                v-model="mdl.deductOneType"
                @change="handleDeductChange"
                @select="selectDeductOne"
                placeholder="请选择"
              >
                <a-select-option v-for="(item, index) in config.deductTypeList" :key="index" :value="item.id">{{
                  item.name
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="扣杂" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input-number
                v-show="tonShow"
                :min="0"
                v-model="mdl.deductOne"
                @change="handleDeductChange"
                style="width: 100%"
              />

              <a-input-number
                v-show="percentShow"
                v-model="mdl.deductOne"
                :min="0"
                :max="100"
                :formatter="(value) => `${value}%`"
                :parser="(value) => value.replace('%', '')"
                style="width: 100%"
                @change="handleDeductChange"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="扣杂类型2" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-select
                v-model="mdl.deductTwoType"
                @change="handleDeductChange"
                @select="selectDeductTwo"
                placeholder="请选择"
              >
                <a-select-option v-for="(item, index) in config.deductTypeList" :key="index" :value="item.id">{{
                  item.name
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item label="扣杂2" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input-number
                v-show="tonShow2"
                :min="0"
                v-model="mdl.deductTwo"
                @change="handleDeductChange"
                style="width: 100%"
              />
              <a-input-number
                v-show="percentShow2"
                v-model="mdl.deductTwo"
                :min="0"
                :max="100"
                :formatter="(value) => `${value}%`"
                :parser="(value) => value.replace('%', '')"
                style="width: 100%"
                @change="handleDeductChange"
              />
            </a-form-item>
          </a-col>-->

          <!--<a-col :span="12">
            <a-form-item label="扣重" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input v-model="mdl.deductTon" :min="0" :disabled="disabled"/>
            </a-form-item>
          </a-col>-->
          <!--<a-col :span="12">
            <a-form-item label="实重" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
              <a-input v-model="mdl.factOne" :disabled="disabled"/>
            </a-form-item>
          </a-col>-->

          <a-col :span="12">
            <span>备注：以上重量单位都为吨</span>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
    import Vue from 'vue'
    import {ACCESS_TOKEN} from '@/store/mutation-types'
    import {STable} from '@/components'
    import {
        logisticsPage,
        logisticsExport,
        logisticsBackStep,
        logisticsCorrectRecord,
        logisticsSetDeleted,
        setCustomerChange
    } from '@/api/logistics'
    import {getCorpSupplierList, corpBusinessList} from '@/api/basic'
    import {formatDate} from '@/utils/date.js'
    import {ReservationStatus} from '@/utils/config.js'
    import {getLogStatusTextByValue, getBizTextByValue} from '@/utils/util'
    import storage from '@/utils/storage'
    import {findPrivileBycode} from '@/api/sys'
    import moment from 'moment'

    import queryMixin from '@/mixins/queryMixin'

    export default {
        name: 'LogisticsList',
        mixins: [queryMixin],
        components: {
            STable,
        },

        data() {
            return {
                precision:2,
                pageSizeOptionsList: ['10'],
                description:
                    '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
                visible: false,
                confirmLoading: false,
                changeBusinessVisable: false,
                changeBusinessform: this.$form.createForm(this),
                // form: null,
                form: this.$form.createForm(this),
                mdl: {},
                mdlc: {},
                roleId: null,
                rolelimit: false,
                bizCodeList: {},
                bizList: [],

                selectedBizId: null,
                supplierList: [],
                businessList: [],
                supplierOrBusList: [],
                supplierOrBusId: null,

                statusList: [{name: '未完结', value: this.config.logistics_status_no_finish}], // 默认查询未完结
                // 高级搜索 展开/关闭
                advanced: false,
                // 查询参数
                queryParam: null, // 默认查询未完结

                disabled: true,
                showLoading: false,

                materielList: [],
                materielId: null,

                tonShow: true,
                percentShow: false,
                tonShow2: true,
                percentShow2: false,

                // 表头
                columns: [
                    {
                        title: '物流单号',
                        dataIndex: 'logisticsNo',
                        width: '200px',
                        fixed: 'left'
                    },
                    {
                        title: '车号',
                        dataIndex: 'vehicleNo',
                        width: '150px'
                    },
                    {
                        title: '卡号',
                        dataIndex: 'cardNo',
                        width: '150px'
                    },
                    {
                        title: '业务类型',
                        dataIndex: 'businessTypeId',
                        width: '110px',
                        customRender: (text, record) => {
                            return getBizTextByValue(this.$store.getters.bizList, record.businessTypeId, text)
                        }
                    },
                    {
                        title: '物流状态',
                        dataIndex: 'logStatus',
                        width: '150px',
                        customRender: (text, record) => {
                            return getLogStatusTextByValue(this.bizCodeList, record.businessTypeId, text)
                        }
                    },
                    {
                        title: '客户/供应商',
                        dataIndex: 'supplierName',
                        width: '240px',
                        scopedSlots: {customRender: 'supplierName'},
                        sorter: true
                    },
                    {
                        title: '货物名称',
                        dataIndex: 'materielName',
                        width: '200px',
                        scopedSlots: {customRender: 'materielName'},
                        sorter: true
                    },
                    {
                        title: '是否一车多货',
                        dataIndex: 'moreThan',
                        width: '140px',
                        customRender: text => {
                            if (text === '1') {
                                return '是'
                            } else {
                                return '否'
                            }
                        }
                    },
                    {
                        title: '司机名称',
                        dataIndex: 'driverName',
                        width: '110px'
                    },
                    {
                        title: '手机号',
                        dataIndex: 'phone',
                        width: '120px'
                    },
                    {
                        title: '创建时间',
                        // sorter: true,
                        dataIndex: 'createTime',
                        width: '180px',
                        sorter: true,
                        customRender: text => {
                            const date = new Date(text)
                            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
                        }
                    },
                    {
                        title: '磅单状态',
                        // sorter: true,
                        scopedSlots: {customRender: 'serial'},
                        dataIndex: 'deleted',
                        width: '100px',

                    },
                    {
                        title: '操作',
                        width: '250px',
                        fixed: 'right',
                        dataIndex: 'action',
                        scopedSlots: {customRender: 'action'}
                    }
                ],
                // 加载数据方法 必须为 Promise 对象
                loadData: parameter => {
                    // 带时分秒的日期时间参数
                    /*        if (this.queryParam.createTime !== undefined && this.queryParam.createTime.length > 1) {
                      this.queryParam['startCreateTime'] = formatDate(new Date(this.queryParam.createTime[0]), 'yyyy-MM-dd hh:mm:ss')
                      this.queryParam['endCreateTime'] = formatDate(new Date(this.queryParam.createTime[1]), 'yyyy-MM-dd hh:mm:ss')
                    } else {
                      this.queryParam['startCreateTime'] = null
                      this.queryParam['endCreateTime'] = null
                    } */
                    // 不带时分秒的日期时间参数
                    if (this.queryParam.createTime !== undefined && this.queryParam.createTime.length > 1) {
                        this.queryParam['startDate'] = formatDate(new Date(this.queryParam.createTime[0]), 'yyyy-MM-dd')
                        this.queryParam['endDate'] = formatDate(new Date(this.queryParam.createTime[1]), 'yyyy-MM-dd')
                    } else {
                        this.queryParam['startDate'] = null
                        this.queryParam['endDate'] = null
                    }
                    if (this.queryParam.supplierOrBusId) {
                        if (this.selectedBizId === this.config.BusinessTypeId.purchase) {
                            this.queryParam.corpSupplierId = this.queryParam.supplierOrBusId
                        }
                        if (this.selectedBizId === this.config.BusinessTypeId.sell) {
                            this.queryParam.corpBusinessId = this.queryParam.supplierOrBusId
                        }
                    } else {
                        this.queryParam.corpSupplierId = null
                        this.queryParam.corpBusinessId = null
                    }
                    return logisticsPage(Object.assign(parameter, this.queryParam)).then(res => {
                        setTimeout(() => {
                            $('.blacktr').parents('tr').css("background-color", "#cf3659")
                            $('.removeblacktr').parents('tr').css("background-color", "#fff")

                        }, 1000);
                        return res.data
                    })
                },

                selectedRowKeys: [],
                selectedRows: []
            }
        },

        created() {
            this.checkButtonPrivilege()
            this.loadSupplierSelect()
            this.loadBusinessSelect()
            this.bizCodeList = this.$store.getters.bizCodeList
            this.bizList = this.$store.getters.bizList
            this.roleId = this.$store.getters.roles
            // 初始化查询条件
            if (!this.queryParam) {
                this.queryParam = {
                    logStatus: this.config.logistics_status_no_finish,
                    createTime: [moment().startOf('day'), moment().endOf('day')],
                    deleted: undefined
                }
            } else {
                if (this.queryParam.createTime.length > 0) {
                    this.queryParam.createTime[0] = moment(this.queryParam.createTime[0])
                    this.queryParam.createTime[1] = moment(this.queryParam.createTime[1])
                }
            }
        },

        methods: {
          correctRecord(record) {
                console.log(this.mdl)
                console.log(record)
                if (record.businessTypeId === 101) {
                    this.mdl.businessTypeName = '销售'
                }
                if (record.businessTypeId === 102) {
                  this.mdl.businessTypeName = '采购'
                }
                this.mdl.logisticsNo=record.logisticsNo
               // this.mdl.supplierOrBusName = record.businessName;
                let supplierOrBusName = this.getNameById(record.corpSupplierId, record.corpBusinessId)
                this.mdl.supplierOrBusName = supplierOrBusName;
                this.materielId = record.materielName;

                var weighing=record.materielList[0].weighing
                if(weighing){
                    this.mdl.tare=weighing.tare
                    this.mdl.gross=weighing.gross
                    this.mdl.net=weighing.net
                }
                this.form = this.$form.createForm(this)
                // 弹出框显示
                this.visible = true
            },
            changeBusinessOk() {

                new Promise(resolve => {
                    const data = setCustomerChange({
                        logisticsNo: this.mdlc.logisticsNo,
                        id2: this.mdlc.id2
                    }).then(res => {
                        return res.data
                    })
                    resolve(data)
                }).then(res => {

                    this.changeBusinessVisable = false
                    this.$refs.table.refresh()
                })


                // yyedit(Object.assign({}, { materialid: kthis.mdl.materielId, vehicleno: kthis.mdl.vehicleNo, driver: kthis.mdl.driverName, tell: kthis.mdl.phone, logisticsNo: kthis.mdl.logisticsNo, appointedDate: kthis.mdl.appointedDate, predictQuantity: kthis.mdl.predictQuantity }))
                //  .then(res => {
                //   if (res.code === '0') {
                //   kthis.$refs.table.refresh()
                // }
                //})
                //.catch(() => { })
                //.finally(() => {
                // kthis.yyeditvisible = false
                //})
            },
            changeBusiness(record) {

                console.log(record.vehicleNo);
                this.mdlc = Object.assign({}, record)

                //每次打开弹窗之前重置下form表单
                this.changeBusinessform = this.$form.createForm(this)

                this.mdlc.logisticsNo = record.logisticsNo
                this.mdlc.yname = record.businessName
                console.log("物流号:" + record.logisticsNo)

                this.changeBusinessVisable = true

            },

            //分配物流记录按钮权限
            checkButtonPrivilege(record) {

                new Promise(resolve => {
                    const data = findPrivileBycode({code: 'wljl-handler'}).then(res => {
                        return res.data
                    })
                    resolve(data)
                }).then(res => {

                    if (res == 'wljl-handler') {
                        this.rolelimit = true
                    }
                })

            },
            moment,
            disabledDate(current) {
                // Can not select days before today and today
                return current && current > moment().endOf('day')
            },
            keepTwoDecimal(num) {
                var result = parseFloat(num)
                if (isNaN(result)) {
                    return ''
                }
                result = Math.round(num * 100) / 100
                return result
            },

            handleGrossChange(value) {
                let net = Number(value) - Number(this.mdl.tare)
                net = this.keepTwoDecimal(net)
                // net = net.toFixed(2);
                this.mdl.net = net >= 0 ? net : 0
                this.$forceUpdate();
              //  this.handleDeductChange()
            },
            handleTareChange(value) {
                let net = Number(this.mdl.gross) - Number(value)
                net = this.keepTwoDecimal(net)
                // net = net.toFixed(2);
                this.mdl.net = net >= 0 ? net : 0
                this.$forceUpdate();
               // this.handleDeductChange()
            },
            handleDeductChange() {
                let deductOne = 0
                let deductTwo = 0
                if (this.mdl.deductOneType === this.config.deductType.ton) {
                    deductOne = this.mdl.deductOne
                }
                if (this.mdl.deductOneType === this.config.deductType.percent) {
                    deductOne = Number(this.mdl.net) * Number(this.mdl.deductOne) * 0.01
                }
                if (this.mdl.deductTwoType === this.config.deductType.ton) {
                    deductTwo = this.mdl.deductTwo
                }
                if (this.mdl.deductTwoType === this.config.deductType.percent) {
                    deductTwo = Number(this.mdl.net) * Number(this.mdl.deductTwo) * 0.01
                }
                var val = Number(deductOne) + Number(deductTwo)
                val = this.keepTwoDecimal(val)
                /*        if(!isNaN(parseFloat(val))) {
                  val = val.toFixed(3);
                } */
                this.mdl.deductTon = val
                var fact = Number(this.mdl.net) - Number(this.mdl.deductTon)
                this.mdl.factOne = this.keepTwoDecimal(fact)
            },
            selectDeductOne(value) {
                if (value === this.config.deductType.ton) {
                    this.tonShow = true
                    this.percentShow = false
                }
                if (value === this.config.deductType.percent) {
                    this.tonShow = false
                    this.percentShow = true
                }
            },
            selectDeductTwo(value) {
                if (value === this.config.deductType.ton) {
                    this.tonShow2 = true
                    this.percentShow2 = false
                }
                if (value === this.config.deductType.percent) {
                    this.tonShow2 = false
                    this.percentShow2 = true
                }
            },
            handleBizChange(value) {
                if (value) {
                    if (this.queryParam.logStatus) {
                        this.queryParam.logStatus = ''
                    }
                }
                this.selectedBizId = value
                this.statusList = this.bizCodeList[value]
                //this.statusList.push({ name: '未完结', value: this.config.logistics_status_no_finish }) // 手动添加一个未完结状态
                if (value === this.config.BusinessTypeId.purchase) {
                    this.supplierOrBusList = this.supplierList
                }
                if (value === this.config.BusinessTypeId.sell) {
                    this.supplierOrBusList = this.businessList
                }
            },

            getNameById(corpSupplierId, corpBusinessId) {
                if (corpSupplierId) {
                    for (var i = 0; i < this.supplierList.length; i++) {
                        let supplier = this.supplierList[i]
                        if (supplier.id === corpSupplierId) {
                            return supplier.name
                        }
                    }
                }
                if (corpBusinessId) {
                    for (var i = 0; i < this.businessList.length; i++) {
                        let business = this.businessList[i]
                        if (business.id === corpBusinessId) {
                            return business.name
                        }
                    }
                }
            },
            loadSupplierSelect() {
                new Promise(resolve => {
                    const data = getCorpSupplierList({}).then(res => {
                        return res.data
                    })
                    resolve(data)
                }).then(res => {
                    this.supplierList = res
                })
            },

            loadBusinessSelect() {
                new Promise(resolve => {
                    const data = corpBusinessList({}).then(res => {
                        return res.data
                    })
                    resolve(data)
                }).then(res => {
                    this.businessList = res
                })
            },

            loadBusinessTypeSelect() {
                let bizList = []
                for (var p in this.bizCodeList) {
                    bizList.push(p)
                }
            },

            filterOption(input, option) {
                // 用于下拉列表可搜索
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },

            handleDetail(record) {
                storage.save('cache-LogisticsDetail', JSON.stringify(record))
                // this.$router.push({name: "LogisticsDetail", query: {datas: JSON.stringify(record)}})
                this.$router.push({name: 'LogisticsDetail'})
            },
            handleBackStep(record) {
                const that = this
                this.$confirm({
                    title: '提示',
                    content:
                        '确定要回退吗？当前状态【' +
                        getLogStatusTextByValue(this.bizCodeList, record.businessTypeId, record.status) +
                        '】',
                    onOk() {
                        return logisticsBackStep({logisticsNo: record.logisticsNo}).then(() => {
                            that.$refs.table.refresh()
                        })
                    },
                    onCancel() {
                    }
                })
            },

            handleEdit(record) {
            },
            handleOk() {
                const that = this
                that.showLoading = true
                logisticsCorrectRecord(this.mdl)
                    .then(res => {
                        if (res.code === '0') {
                            that.visible = false
                            that.$refs.table.refresh()
                            that.showLoading = false
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
                    .finally(res => {
                        that.showLoading = false
                    })
            },
            handleDeleted(record) {
                let text
                if (record.deleted === 0) {
                    text = "确定作废吗？"
                } else if (record.deleted === 1) {
                    text = "确定恢复吗？"
                }
                const that = this
                this.$confirm({
                    title: '提示',
                    content:
                    text,
                    onOk() {
                        return logisticsSetDeleted({
                            logisticsNo: record.logisticsNo,
                            deleted: record.deleted
                        }).then(() => {

                            that.$refs.table.refresh()
                        })
                    },
                    onCancel() {
                    }
                })

            },
            handleProDetail(record) {
                storage.save('cache-MaterielDetail', JSON.stringify(record))
                // this.$router.push({name: "MaterielDetail", query: {datas: JSON.stringify(record)}})
                this.$router.push({name: 'MaterielDetail'})
            },

            onChange(selectedRowKeys, selectedRows) {
                this.selectedRowKeys = selectedRowKeys
                this.selectedRows = selectedRows
            },

            toggleAdvanced() {
                this.advanced = !this.advanced
            },

        },
        watch: {}
    }
</script>
